import { useLayoutContext } from 'contexts/LayoutContext';
import { FC } from 'react';
import { BANK_RECONCILIATION } from 'adminConstants/routes';
import { useHistory } from 'react-router-dom';
import { Row } from 'components/Layout';
import { Button, styled, Typography } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import ButtonGroup from 'components/ButtonGroup';
import api from 'lib/trpcClient';
import { CalendarDay } from 'further-ui/utils';

const StyledWarningRow = styled(Row)(({ theme }) => ({
  padding: theme.spacing(5),
  border: `1px solid ${theme.palette.text.error}`,
  borderRadius: 1,
}));

const StyledWarningIcon = styled(InfoOutlined)(({ theme }) => ({
  color: theme.palette.text.error,
  fontSize: 30,
}));

const StyledButtonGroup = styled(ButtonGroup)(() => ({
  minWidth: '200px',
  flexShrink: 0,
}));

const BankReconciliationWarningBox: FC<{
  warningText: string;
  date: Date | null;
}> = ({ warningText, date }) => {
  const { selectedVehicleId } = useLayoutContext();
  const history = useHistory();

  const { data: bankOperationsExist } =
    api.bankAccount.checkBankAccountOperationsExist.useQuery({
      vehicleId: selectedVehicleId ?? '',
      date: new CalendarDay(date ?? new Date()),
    });

  if (!bankOperationsExist) {
    return null;
  }

  return (
    <StyledWarningRow>
      <Row centered spacing="sm">
        <StyledWarningIcon />
        <Typography variant="body2" color="text.error">
          {warningText}
        </Typography>
      </Row>
      <StyledButtonGroup>
        <Button
          variant="outlined"
          color="error"
          size="small"
          onClick={() => history.push(BANK_RECONCILIATION)}
        >
          Go to bank reconciliation
        </Button>
      </StyledButtonGroup>
    </StyledWarningRow>
  );
};

export default BankReconciliationWarningBox;
